/*
 * Article split-page media carousel.
 * Wraps Flickity (already loaded globally on `themeVendor` via vendor.js)
 * so sections/article-split.liquid can show a gallery of images sourced
 * from the article's "gallery_images" metaobject list metafield.
 */
(function () {
  if (window.customElements.get('article-gallery')) return;

  class ArticleGallery extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-flickity-track]');
      const Flickity = window.themeVendor && window.themeVendor.Flickity;

      if (!track || !Flickity) return;

      this.flkty = new Flickity(track, {
        cellSelector: '.article-split__gallery-slide',
        contain: true,
        wrapAround: true,
        // Cells are absolutely positioned internally by Flickity, so on
        // mobile (where .article-split__media has no fixed height) the
        // viewport needs this to measure and follow the selected slide's
        // own height instead of collapsing to 0.
        adaptiveHeight: true,
        pageDots: true,
        prevNextButtons: true,
        setGallerySize: true,
        percentPosition: true,
      });

      this.classList.add('is-initialized');
    }

    disconnectedCallback() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }
  }

  window.customElements.define('article-gallery', ArticleGallery);
})();
